module.exports = __webpack_public_path__ + "static/people_img32-8a77c1da6fa53a5e5eb6637c7979a04a.png";